export default {
  url_record_dev: 'https://expedientes-qa.talisis.com/index.php/login/Token',
  url_record: 'https://expedientes.talisis.com/index.php/login/Token'
}